export function tenantPath(tenantSlug: string, path = ''): string {
  const normalizedPath = path === '/' ? '' : path.replace(/^\//, '');
  return normalizedPath ? `/t/${tenantSlug}/${normalizedPath}` : `/t/${tenantSlug}`;
}

export function tenantSlugFromPath(pathname: string): string | null {
  const match = /^\/t\/([^/]+)(?:\/|$)/.exec(pathname);
  return match?.[1] ?? null;
}
